import EmailOpenQuestion from 'models/common/form/question/open/EmailOpenQuestion';

export default class EmailOpenQuestionService {
	toModel(question) {
		return new EmailOpenQuestion(question);
	}
}
